import './App.css';
import Navbar from './Components/Navbar';
import { BrowserRouter , Routes, Route } from 'react-router-dom';
import Home from './Components/Home';
import Aboutus from './Components/Aboutus';
import Keypersonals from './Components/Keypersonals';
import Services from './Components/Services';
import RebarEstimation from './Components/RebarEstimation';
import RebarDetailing from './Components/ReabarDetailing';
import Excel from './Components/Excel';
import Asa from './Components/Asa';
import Projects from './Components/Projects';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
import CareersPage from './Components/careerspage';

const App = () => {
  return (
   <BrowserRouter>
      <Navbar />
     
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/aboutus/keypersonals" element={<Keypersonals />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/rebar-estimation" element={<RebarEstimation />} />
        <Route path="/services/rebar-detailing" element={<RebarDetailing />} />
        <Route path="/services/excel" element={<Excel />} />
        <Route path="/services/asa" element={<Asa />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/careers" element={<CareersPage />} />
      </Routes>
       <Footer />
      </BrowserRouter>
  );
};

export default App;
